import { render, staticRenderFns } from "./CadastroUsuarioComponent.vue?vue&type=template&id=c4ed6416"
import script from "./CadastroUsuarioComponent.vue?vue&type=script&lang=js"
export * from "./CadastroUsuarioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports